import { Injectable, ViewContainerRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RootService {
  constructor() {}
  container: ViewContainerRef;
}
